import React from 'react';
import { Button } from '../ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { FiMapPin, FiPhone, FiMail, FiGlobe } from 'react-icons/fi';

export const Footer = () => {
  const CONTACT_URL = "https://paduaweddings.com/#contact";
  const TOUR_URL = "https://tour.paduaweddings.com";

  return (
    <footer className="bg-[#1a1817] text-vintage-white relative">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-estate-bronze/40 to-transparent"></div>
      
      <div className="max-w-[1320px] mx-auto px-6 md:px-12 pt-24 pb-12 text-center">
        <div className="mb-24">
          <h2 className="font-serif text-[clamp(2rem,6vw,4rem)] text-white mb-6 leading-tight">Ready for Your Custom Proposal?</h2>
          <p className="text-base md:text-xl text-white/60 font-light max-w-2xl mx-auto mb-12 leading-relaxed">
            Once you have a preferred date, guest count, and menu direction in mind, our team can help draft a detailed proposal that reflects your unique celebration style.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 max-w-2xl mx-auto">
            <Button 
              href={CONTACT_URL}
              className="w-full sm:w-auto bg-olive-grove text-white hover:bg-[#5d6344] border-none px-10 min-h-[52px]"
            >
              Request a Custom Proposal
            </Button>
            <Button 
              href={TOUR_URL}
              variant="outline" 
              className="w-full sm:w-auto border-white/20 text-white hover:bg-white hover:text-deep-charcoal min-h-[52px]"
            >
              Schedule a Tour
            </Button>
          </div>
        </div>

        <div className="w-full h-px bg-white/5 mb-16"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {[
            { icon: FiMapPin, title: "Padua Weddings", sub: "Claremont, CA" },
            { icon: FiPhone, title: "909-624-8628", sub: "Call Us" },
            { icon: FiMail, title: "paduaweddings.com", sub: "Email Us" },
            { icon: FiGlobe, title: "Follow Our Story", sub: "Visit Online" }
          ].map((item, i) => (
            <div key={i} className="flex flex-col items-center group">
              <div className="w-14 h-14 rounded-full border border-white/10 flex items-center justify-center mb-5 group-hover:border-estate-bronze/50 transition-all duration-300">
                <SafeIcon icon={item.icon} className="w-6 h-6 text-estate-bronze" />
              </div>
              <span className="font-serif text-xl mb-1">{item.title}</span>
              <span className="text-[10px] text-white/40 font-bold tracking-[0.2em] uppercase">{item.sub}</span>
            </div>
          ))}
        </div>

        <div className="text-center space-y-6">
          <p className="text-[11px] text-white/30 font-light italic max-w-xl mx-auto leading-relaxed">
            Pricing and availability are subject to change. Final estimates are prepared by the Padua Weddings team based on specific event details and guest counts.
          </p>
          <div className="flex items-center justify-center gap-6">
            <div className="h-px w-12 bg-white/10"></div>
            <p className="text-[11px] text-estate-bronze font-black uppercase tracking-[0.4em]">
              Padua Weddings Master Guide • {new Date().getFullYear()}
            </p>
            <div className="h-px w-12 bg-white/10"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};